module.exports = __webpack_public_path__ + "static/sdk-gifs-c480079ddcc64ebf658c827ea67487aa.gif";